import React, { useCallback, useState, Dispatch, SetStateAction } from "react";

interface Props {
  data: any[];
}

type CommonReturn = [
  (e: boolean, index: number) => void,
  (e: string, index: number) => void,
  string | undefined,
  Dispatch<SetStateAction<string | undefined>>
];

const UseCommonCard = ({ data }: Props): CommonReturn => {
  const [Delete, setDelete] = useState<string | undefined>(undefined);
  /** 블라인드 함수 */
  const UpdateBlind = useCallback((e: boolean, index: number) => {}, [data]);
  /** 순서 변경 함수 */
  const OrderChange = useCallback((e: string, index: number) => {}, [data]);

  return [UpdateBlind, OrderChange, Delete, setDelete];
};

export default UseCommonCard;
